import {NgModule} from '@angular/core';
import {PagesSharedModule} from '../../../pages/pages-shared.module';
import {CombinedInventoryInputComponent} from './combined-inventory-input.component';
import {BarcodeScannerModule} from '../barcode-scanner/barcode-scanner.module';
import {InventoryNumberInputModule} from '../inventory-number-input/inventory-number-input.module';

@NgModule({
    imports: [
        PagesSharedModule,
        BarcodeScannerModule,
        InventoryNumberInputModule
    ],
    declarations: [
        CombinedInventoryInputComponent
    ],
    entryComponents: [],
    exports: [
        CombinedInventoryInputComponent
    ]
})
export class CombinedInventoryInputModule {
}
